import React from 'react'

import './NewAddressOption.css'

export const NewAddressOption = () => (
  <span styleName='newAddress'>Enter a new address...</span>
)
